export const serviceEnum = Object.freeze({
  MonthlyPayment: 1,
  Books: 2,
  Enrollment: 3,
  Other: 5,
  ServiceAssistant: 6,
  SpeechTherapy: 7,
  OccupationalTherapy: 8,
  PsychologicalTherapy: 9,
  ABATherapy: 10,
  OromotorTherapy: 11,
});
